export default __webpack_public_path__ + "static/media/Talonthrust.77da3955.jpg";